import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { ExperienceCard } from "@/components/Cards";
import { TID } from "@/constants/testIds";

const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "food-tours", label: "Food Tours" },
  { key: "surfing", label: "Surfing" },
  { key: "hinterland", label: "Hinterland" },
  { key: "wellness", label: "Wellness" },
  { key: "photography", label: "Photography" },
  { key: "nightlife", label: "Nightlife" },
  { key: "luxury", label: "Luxury" },
  { key: "family", label: "Family" },
];

export default function Experiences() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState(params.get("cat") || "all");

  useEffect(() => {
    api.get("/experiences", { params: { category: cat } }).then((r) => setItems(r.data));
  }, [cat]);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-24">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-7">
          <span className="editorial-divider" />
          <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">Experiences.</h1>
        </div>
        <div className="md:col-span-4 md:col-start-9">
          <p className="text-[color:var(--forest-2)] leading-relaxed">
            Hosted by locals who've spent their lives on this coast. Small groups. Real stories. Book directly with hosts.
          </p>
        </div>
      </motion.div>

      <div className="mt-10 flex flex-wrap gap-2">
        {CATEGORIES.map((c) => (
          <button
            key={c.key}
            data-testid={TID.expCategoryFilter(c.key)}
            onClick={() => { setCat(c.key); setParams({ cat: c.key }); }}
            className={`chip ${cat === c.key ? "chip-active" : ""}`}
          >
            {c.label}
          </button>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {items.map((e, i) => <ExperienceCard key={e.id} exp={e} index={i} />)}
      </div>
    </div>
  );
}
